var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { DefaultButton, Label, Stack, TextField } from "@fluentui/react";
import { useCallback, useMemo, useRef, useState } from "react";
import { useClasses } from "../../utils/useClasses";
var getClasses = function () { return ({
    handler: {
        display: "none",
    },
    holder: {}
}); };
var tokens = {
    "body": {
        childrenGap: 12
    }
};
export function joinFileNames(files, separator) {
    if (!(files === null || files === void 0 ? void 0 : files.length))
        return undefined;
    var names = "";
    var useSep = false;
    for (var i = 0, len = files.length; i < len; i++) {
        var file = files[i];
        if (useSep)
            names += separator;
        else
            useSep = true;
        names += file.name;
    }
    return names;
}
export var FilePicker = function (props) {
    var id = props.id, label = props.label, placeHolder = props.placeHolder, multiple = props.multiple, types = props.types, disabled = props.disabled, required = props.required, onChange = props.onChange, onPicked = props.onPicked, value = props.value;
    var classes = useClasses(getClasses);
    var handlerRef = useRef(null);
    var _a = useState(), files = _a[0], setFiles = _a[1];
    var fileNames = useMemo(function () {
        var fs;
        if (value) {
            if (typeof value === "string")
                return value;
            fs = value;
        }
        else
            fs = files;
        return joinFileNames(fs, ";");
    }, [value, files]);
    var handler = useMemo(function () {
        return _jsx("input", { className: classes.handler, id: id, ref: handlerRef, type: "file", multiple: multiple, accept: types === null || types === void 0 ? void 0 : types.join(","), onChange: function (evt) {
                var picks = evt.target.files;
                if (!(picks === null || picks === void 0 ? void 0 : picks.length)) {
                    setFiles(undefined);
                    return;
                }
                var res = [];
                for (var i = 0, len = picks.length; i < len; i++) {
                    var file = picks[i];
                    res.push(file);
                }
                setFiles(res);
                onPicked === null || onPicked === void 0 ? void 0 : onPicked(res);
                onChange === null || onChange === void 0 ? void 0 : onChange(evt, res);
            } }, void 0);
    }, [multiple, types, classes.handler, id, onChange, onPicked]);
    var onOpen = useCallback(function () {
        var _a;
        (_a = handlerRef.current) === null || _a === void 0 ? void 0 : _a.click();
    }, []);
    return (_jsxs("div", { children: [handler, label && _jsx(Label, __assign({ disabled: disabled, required: required }, { children: label }), void 0), _jsxs(Stack, __assign({ horizontal: true, tokens: tokens.body }, { children: [_jsx(Stack.Item, __assign({ grow: true }, { children: _jsx(TextField, { placeholder: fileNames || placeHolder || "Browse to pick", disabled: true }, void 0) }), void 0), _jsx(DefaultButton, __assign({ onClick: onOpen, disabled: disabled }, { children: "Browse" }), void 0)] }), void 0)] }, void 0));
};
//# sourceMappingURL=FilePicker.js.map